import React, { useState, useEffect} from "react";
import { apiClient } from "../api_client";
import { InfoTooltip } from "./InfoTooltip";


export default function EventCreation({ persistedEventInfo, onSuccess, eventId }) {
  const today = new Date().toISOString().split("T")[0];
  const [eventInfoData, setEventInfoData] = useState({
    name: "",
    description: "",
    date: today,
    image: null,
    bib_group_total: 1,
    organiser_name: persistedEventInfo.organiser_name,
    organiser_email: persistedEventInfo.organiser_email,
  });

  function fileToBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onloadend = () => {
        resolve(reader.result);
      };

      reader.onerror = reject;

      reader.readAsDataURL(file);
    });
  }

  const eventSubmit = async (e) => {
    e.preventDefault();

    let imageJson = "";
    if (eventInfoData.image && eventInfoData.image.length > 0) {
      imageJson = await fileToBase64(eventInfoData.image[0]);
    }

    const event = {
        name: eventInfoData.name,
        description: eventInfoData.description,
        date: eventInfoData.date,
        image: imageJson,
        organiser_name: eventInfoData.organiser_name,
        organiser_email: eventInfoData.organiser_email,
        event_id: eventId,
      };

    try {
      const response = await apiClient.events.create(event);
      if (eventId == 0) {
        showToast("Event created successfully!", "success");
      }
      else {
        showToast("Event info updated!", "success")
      }
      if (onSuccess) {
        onSuccess(response.id, eventInfoData);
      }

    } catch (e) {
      console.error("Failed to make event", e);
      showToast(e, "error");
    }
  };

  useEffect(() => {
    setEventInfoData({
      name: persistedEventInfo.name,
      description: persistedEventInfo.description,
      date: persistedEventInfo.date,
      image: persistedEventInfo.image,
      bib_group_total: persistedEventInfo.bib_group_total,
      organiser_name: persistedEventInfo.organiser_name,
      organiser_email: persistedEventInfo.organiser_email,
    });
  
  }, [persistedEventInfo]);

  return (
    <form onSubmit={eventSubmit}>
      <div className="mb-3">
        <label htmlFor="title">Title</label>
        <input
          id="title"
          className="form-control"
          required={true}
          defaultValue={eventInfoData.name}
          onChange={(e) =>
            setEventInfoData({ ...eventInfoData, name: e.target.value })
          }
        />
      </div>
      <div className="mb-3">
        <label htmlFor="description">Description</label>
        <InfoTooltip>Length, elevation gain, difficulty.</InfoTooltip>
        <input
          id="description"
          className="form-control"
          defaultValue={eventInfoData.description}
          onChange={(e) =>
            setEventInfoData({ ...eventInfoData, description: e.target.value })
          }
        />
      </div>
      <div className="mb-3">
        <label htmlFor="date">Date:</label>
        <InfoTooltip>The date of when the event will take place.</InfoTooltip>
        <input
          id="date"
          className="form-control"
          type="date"
          value={eventInfoData.date || ""}
          required={true}
          onChange={(e) =>
            setEventInfoData({ ...eventInfoData, date: e.target.value })
          }
        />
      </div>
      <div className="mb-3">
        <label htmlFor="imageInput">
          Upload Image
        </label>
        <InfoTooltip>
          This image will be shown on the event page on the app. Supported formats: JPEG, PNG, GIF, WEBP.
        </InfoTooltip>

        <input
          id="imageInput"
          className="form-control"
          type="file"
          accept="image/jpeg,image/png,image/gif,image/webp"
          onChange={(e) =>
            setEventInfoData({ ...eventInfoData, image: e.target.files })
          }
        />
      </div>
      <div className="mb-3">
        <label htmlFor="bib-groups-num">How Many Bib Groups</label>
        <InfoTooltip>
          How many different categories of bib numbers do you want? For example, you might want separate bib groups for adults and children.
        </InfoTooltip>
        <input
          id="bib-groups-num"
          className="form-control"
          value={eventInfoData.bib_group_total}
          onChange={(e) =>
            setEventInfoData({
              ...eventInfoData,
              bib_group_total: e.target.value,
            })
          }
        />
      </div>
      <div className="mb-3">
        <label htmlFor="org-name">Organiser Name</label>
        <InfoTooltip>
          Who should the entrants contact if they have questions about the event?
        </InfoTooltip>
        <input
          id="org-name"
          className="form-control"
          required={true}
          defaultValue={eventInfoData.organiser_name}
          onChange={(e) =>
            setEventInfoData({ ...eventInfoData, organiser_name: e.target.value })
          }
        />
      </div>
      <div className="mb-3">
        <label htmlFor="org-email">Organiser Email</label>
        <InfoTooltip>
          This doesn't have to be the email used to sign in to Beacon Racing.
        </InfoTooltip>
        <input
          id="org-email"
          className="form-control"
          required={true}
          defaultValue={eventInfoData.organiser_email}
          onChange={(e) =>
            setEventInfoData({ ...eventInfoData, organiser_email: e.target.value })
          }
        />
      </div>
      <button type="submit" id="event-submit" className="btn btn-success">
        Save + Continue
      </button>
    </form>
  );
}